var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.6983 13.6983",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.27124 9.42707L0.5 13.1983M6.48303 3.44407L5.44244 4.48466C5.35755 4.56955 5.31511 4.61199 5.26676 4.64571C5.22384 4.67565 5.17754 4.70042 5.12883 4.71953C5.07395 4.74106 5.01509 4.75283 4.89738 4.77637L2.4544 5.26496C1.81954 5.39194 1.5021 5.45543 1.35359 5.62279C1.22422 5.7686 1.16514 5.96373 1.1919 6.15681C1.22263 6.37845 1.45154 6.60735 1.90935 7.06516L6.63317 11.789C7.09098 12.2468 7.31989 12.4757 7.54152 12.5064C7.73461 12.5332 7.92974 12.4741 8.07554 12.3447C8.24291 12.1962 8.3064 11.8788 8.43337 11.2439L8.92197 8.80096C8.94551 8.68325 8.95728 8.62439 8.97881 8.56951C8.99791 8.52079 9.02269 8.4745 9.05262 8.43158C9.08635 8.38322 9.12879 8.34078 9.21367 8.2559L10.2543 7.21531C10.3085 7.16104 10.3357 7.1339 10.3655 7.11021C10.392 7.08917 10.4201 7.07017 10.4494 7.05338C10.4825 7.03448 10.5178 7.01937 10.5883 6.98914L12.2512 6.27646C12.7364 6.06855 12.9789 5.96459 13.0891 5.7966C13.1855 5.6497 13.2199 5.4707 13.185 5.29851C13.1451 5.10162 12.9585 4.91501 12.5853 4.54179L9.15654 1.11303C8.78333 0.739817 8.59672 0.553209 8.39982 0.513294C8.22764 0.47839 8.04864 0.512862 7.90174 0.609217C7.73375 0.719402 7.62979 0.961968 7.42187 1.4471L6.7092 3.11001C6.67897 3.18055 6.66385 3.21582 6.64496 3.2489C6.62817 3.27828 6.60917 3.30634 6.58812 3.33284C6.56443 3.36267 6.5373 3.3898 6.48303 3.44407Z",
    stroke: "var(--stroke-0, white)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin02);
export default __webpack_public_path__ + "static/media/pin-02.aaf6675542d80641fb434f9622e5fa44.svg";
export { ForwardRef as ReactComponent };